import React from 'react'
import '../Styles/GetInvolvedPage1.scss';

function GetInvolvedPage1() {
   return(
      <div className="getInvolvedPage1Content">
         <div className="getInvolvedPage1Container">
            <div className="getInvolvedPage1TitleContainer">
               <div className="getInvolvedPage1Title">
                  Get Involved
               </div>
            </div>
            <div className="getInvolvedPage1Description">
               Camp connect offers many ministry opportunities to high school and college aged men and women.<br></br>
               High school aged young man can choose to work in foodservice for two sessions at the begging <br></br>
               and end of the summer, while highschool aged man and women help in leadership with the camp <br></br>
               internship program. College aged men and women are needed each summer as summer staff where <br></br>
               they invest in junior and teenager's lives. Come get involved at Camp Connect and experience <br></br>
               the greatest summer of your life!
            </div>
         </div>
      </div>
   )
}
export default GetInvolvedPage1;